import { observer } from 'mobx-react-lite';

import CatalogItem from '../catalog-item';

import cartStore from 'src/stores/cart-store';
import catalogStore from 'src/stores/catalog-store';

import useCatalogScrolling from 'src/hooks/use-catalog-scrolling';
import type { CatalogSectionProps } from './catalog-section.props';

import './catalog-section.scss';

const CatalogSection = observer(
  ({ categoryData: { category, items, title }, setCategoryRef }: CatalogSectionProps) => {
    const { setActiveCategory } = catalogStore;
    const { decrementLot, incrementLot, getCountInCart } = cartStore;

    const ref = useCatalogScrolling({ category, setActiveCategory, setCategoryRef });

    return (
      <div className="catalog-section" key={category} ref={ref}>
        <div className="catalog-section__title">{title}</div>
        <div className="catalog-section__content">
          {items.map((item) => (
            <CatalogItem
              key={item.id}
              addedToCart={getCountInCart(item.id)}
              item={item}
              decrementItem={() => decrementLot(item.id)}
              incrementItem={() => incrementLot(item.id)}
            />
          ))}
        </div>
      </div>
    );
  }
);

export default CatalogSection;
